export default __webpack_public_path__ + "static/media/paddle88.274213e2.png";